"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _member = require("@/api/member/member");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { batchUpdateUserGradeInviter, getGradeMap } from '@/api/member'
var _default = exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      options: [],
      grade: '',
      fileList: [],
      unrecognizedList: [] // 失败的邀请码
    };
  },
  created: function created() {
    this.memberQueryMemberGradeApi();
  },
  methods: {
    open: function open() {
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.fileList = [];
      this.grade = '';
      this.unrecognizedList = [];
    },
    handleClose: function handleClose(done) {
      done();
    },
    handleChangeFile: function handleChangeFile(e) {
      console.log(e);
      this.fileList.push(e);
    },
    onRemove: function onRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = [];
    },
    verify: function verify() {
      var _this = this;
      if (!this.grade) {
        this.$message({
          type: 'warning',
          message: '请选择等级!'
        });
        return;
      }
      if (this.fileList.length === 0) {
        this.$message({
          type: 'warning',
          message: '请上传文件!'
        });
        return;
      }
      this.$confirm('确认提交？').then(function (_) {
        _this.sureEditFans();
      }).catch(function (_) {});
    },
    sureEditFans: function () {
      var _sureEditFans = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var formData, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              formData = new FormData();
              formData.append('file', this.fileList[this.fileList.length - 1].raw);
              formData.append('grade', this.grade);
              _context.n = 1;
              return (0, _member.importMemberGradeTemplate)(formData);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                if (!res.data.notExistInviteCodes) {
                  this.$notify.success({
                    title: '温馨提示',
                    message: '修改成功'
                  });
                  this.fileList = [];
                  this.dialogVisible = false;
                  this.$emit('refresh');
                } else {
                  this.unrecognizedList = res.data.notExistInviteCodes;
                }
              } else {
                this.unrecognizedList = res.data.notExistInviteCodes;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function sureEditFans() {
        return _sureEditFans.apply(this, arguments);
      }
      return sureEditFans;
    }(),
    memberQueryMemberGradeApi: function () {
      var _memberQueryMemberGradeApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _member.memberQueryMemberGradeApi)();
            case 1:
              res = _context2.v;
              this.options = res.data;
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.log(_t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function memberQueryMemberGradeApi() {
        return _memberQueryMemberGradeApi2.apply(this, arguments);
      }
      return memberQueryMemberGradeApi;
    }()
  }
};